import React, { useState } from 'react'
import styled from 'styled-components'
import ChatCard from './Networking/ChatCard'
import { COLORS } from '../styles/theme'
import { LiveQuestions } from './LiveQuestions/'
import useQuestion from '../utils/questionHelper'
import useChat from '../utils/chatHelper'
import { AuditoriumChat, AuditoriumQuestion } from 'src/firebaseConfig'

const ChatContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(5, 46, 104, 0.6);
  backdrop-filter: blur(18px);
  color: #fff;
  padding: 32px 32px;

  @media (max-width: 768px) {
    padding: 16px 16px;
  }

  h4 {
    text-align: center;
    margin: 16px;
  }
  .tabs {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    gap: 8px;

    .flex-1 {
      flex: 1;
    }

    .active {
      small {
        color: #fff;
      }
      button {
        background: var(--blue-01);
        border-color: #fff;
      }
    }
    button {
      width: 100%;
      height: 60px;
      padding: 0 6px;
      background: white;
      border: 2px solid var(--blue-01);
      appearance: none;
      outline: none;
      small {
        font-size: 14px;
        font-weight: 600;
        color: var(--blue-01);
      }
    }
  }
  .toggle-content {
    margin: 16px 0;
    color: black;
    height: 100%;
    .ques-container {
      height: 100%;
      .ques-text {
        height: 60%;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 8px;
        margin-bottom: 16px;
        font-size: 14px;
      }
    }
  }
  form {
    width: 100%;
    max-height: 100px;
    text-align: right;
    textarea {
      min-height: 45px;
      resize: none;
      outline: none;
      border: 3px solid ${COLORS.primary};
      background: white;
      border-radius: 8px;
      padding: 8px;
      width: 100%;
      &::placeholder {
        font-size: 12px;
        font-style: italic;
      }
    }

    .btn {
      font-size: 12px;
      font-weight: 600;
      color: ${COLORS.primary};
      background: transparent;
      cursor: pointer;
      svg {
        margin: 0 4px;
      }
    }
  }
  #refresh-btn {
    border: none;
    background: white;
    padding: 5px 10px;

    &:hover {
      border: solid 1px ${COLORS.primary};
    }
  }
`

export default function ChatSection({ currentUser, firebaseDb, chatDb }) {
  const {
    messages: questions,
    messagesLoading: questionsLoading,
    submitLoading: questionSubmitLoading,
    handleSubmitQuestion,
    fetchLoading: questionFetchLoading,
    scrollTrigger: questionScrollTrigger,
  } = useQuestion(AuditoriumQuestion)

  const {
    messages,
    messagesLoading,
    messagesError,
    handleSubmitMessage,
    submitLoading,
    submitError,
    handleFetchOlderMessages,
    fetchLoading,
    fetchError,
    scrollTrigger,
  } = useChat(AuditoriumChat)

  const [showChat, setShowChat] = useState(true)

  const refreshPage = () => {
    window.location.reload()
  }

  return (
    <ChatContainer>
      <div className="tabs">
        <div className={`flex-1 ${!showChat && 'active'}`} onClick={() => setShowChat(false)}>
          <button>
            <small>Question Submission</small>
          </button>
        </div>
        <div className={`flex-1 ${showChat && 'active'}`} onClick={() => setShowChat(true)}>
          <button>
            <small>Live Chat</small>
          </button>
        </div>
      </div>
      <div className="toggle-content">
        {showChat ? (
          messagesError ? (
            <button id="refresh-btn" onClick={refreshPage}>
              Connection failed. Click here to refresh.
            </button>
          ) : (
            <ChatCard
              // toggleAvatar={toggleAvatar}
              messages={messages}
              messagesLoading={messagesLoading}
              handleSubmitMessage={handleSubmitMessage}
              submitLoading={submitLoading}
              handleFetchOlderMessages={handleFetchOlderMessages}
              fetchLoading={fetchLoading}
              scrollTrigger={scrollTrigger}
              currentUser={currentUser}
            />
          )
        ) : (
          <LiveQuestions
            messages={questions}
            messagesLoading={questionsLoading}
            handleSubmitMessage={handleSubmitQuestion}
            submitLoading={questionSubmitLoading}
            fetchLoading={questionFetchLoading}
            scrollTrigger={questionScrollTrigger}
            currentUser={currentUser}
          />
          // <div className="ques-container">
          //   <div className="ques-text p-3">
          //     Questions will be sent directly to the organiser.
          //   </div>
          //   <GoogleSheetForm hallName={hallName} />
          // </div>
        )}
      </div>
    </ChatContainer>
  )
}
